import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { scrollToId } from "@/components/Reveal";

const LINKS = [
  { id: "packages", label: "Packages" },
  { id: "gallery", label: "Gallery" },
  { id: "reviews", label: "Reviews" },
];

export default function Nav() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => {
    setOpen(false);
    scrollToId(id);
  };

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-espresso-deep/85 backdrop-blur-xl border-b border-cream/10" : "bg-transparent"
      }`}
    >
      <nav className="mx-auto flex max-w-7xl items-center justify-between px-5 py-4 sm:px-8">
        <button
          data-testid="nav-logo-button"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="flex items-center gap-3"
        >
          <img src="/logo-badge.png" alt="Shaken Society badge" className="h-10 w-10 rounded-full object-cover" />
          <span className="font-display text-xl tracking-wide text-cream sm:text-2xl">
            Shaken <span className="italic text-rose">Society</span>
          </span>
        </button>

        <div className="hidden items-center gap-8 md:flex">
          {LINKS.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-link-${l.id}`}
              onClick={() => go(l.id)}
              className="text-[13px] font-medium uppercase tracking-[0.18em] text-cream/70 transition-colors hover:text-gold"
            >
              {l.label}
            </button>
          ))}
          <button
            data-testid="nav-book-cta"
            onClick={() => go("book")}
            className="rounded-full bg-gold px-6 py-2.5 text-[13px] font-semibold uppercase tracking-[0.18em] text-espresso transition-transform duration-200 hover:scale-105"
          >
            Book your date
          </button>
        </div>

        <button
          data-testid="nav-mobile-toggle"
          className="text-cream md:hidden"
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu"
        >
          {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </nav>

      {open && (
        <div className="border-t border-cream/10 bg-espresso-deep/95 px-6 py-6 backdrop-blur-xl md:hidden">
          <div className="flex flex-col gap-5">
            {LINKS.map((l) => (
              <button
                key={l.id}
                data-testid={`nav-mobile-link-${l.id}`}
                onClick={() => go(l.id)}
                className="text-left text-sm font-medium uppercase tracking-[0.18em] text-cream/80"
              >
                {l.label}
              </button>
            ))}
            <button
              data-testid="nav-mobile-book-cta"
              onClick={() => go("book")}
              className="rounded-full bg-gold px-6 py-3 text-sm font-semibold uppercase tracking-[0.18em] text-espresso"
            >
              Book your date
            </button>
          </div>
        </div>
      )}
    </header>
  );
}